(function triggeredEmailSurveys($, Adzuki)
{
	"use strict";
	var $modal = $(".modal");

	$(document).ready(function documentReady()
	{
		Adzuki.onload('Reports/triggeredEmailSurveys', function onload() {
			$(".triggered-survey-submission").click(function viewSurveyDetail(event) {
				var $self = $(this),
				    id    = $self.data('id'),
				    title = $self.data('modal-title'),
				    url   = Adzuki.base_uri + '/Reports/triggeredEmailSurveysView/' + id;

				event.preventDefault();
				$modal.find('.modal-body').text('Loading details...');
				$modal.find('.modal-title').text(title);
				$modal.modal('show');

				Adzuki.Ajax.get(url)
				.then(function showDetails(data) {
					$modal.find('.modal-body').html(data);
				});
			});
		});
	});
}(jQuery, window.Adzuki || {}));
